import React, { useEffect, useState } from "react";
import comunidade from "../../../services/comunidade";
import { Box, CircularProgress } from "@mui/material";
import { TableContainer } from "@mui/material";
import { Table } from "@mui/material";
import { TableRow } from "@mui/material";
import { TableCell } from "@mui/material";
import { TableHead } from "@mui/material";
import { TableBody } from "@mui/material";
import { useHistory } from "react-router-dom";
import ActionTable from "../../../components/table/ActionTable";

export default function Lista() {
  const [eventos, setEventos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const history = useHistory();

  useEffect(() => {
    listar();
  }, []);

  const listar = () => {
    let filtros = { nome: "" };
    setCarregando(true);
    comunidade
      .get("eventos/listar", filtros)
      .then((eventos) => {
        eventos.forEach(
          (e) =>
            (e.inicio = e.inicio
              ? new Date(e.inicio).toLocaleString("pt-BR")
              : "-")
        );
        setEventos(eventos);
        setCarregando(false);
      })
      .catch((e) => alert("Erro ao listar os usuários: " + e));
  };

  const tEventos = {
    title: "Eventos",
    onLineClick: (id) => history.push(`/app/comunidade-eventos/${id}`),
    key: "id",
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
      {
        label: "Início",
        name: "inicio",
      },
    ],
    array: eventos,
  };

  return (
    <div>
      {carregando ? <CircularProgress /> : <ActionTable structure={tEventos} />}
      {/* <Box
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          marginTop: "30px",
          marginBottom: 5,
        }}
      >
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Eventos</TableCell>
                <TableCell></TableCell>
              </TableRow>
              <TableRow sx={{ background: "#F4F7FA" }}>
                <TableCell>Nome</TableCell>
                <TableCell>Ínicio</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {eventos.map((evento) => (
                <TableRow
                  hover
                  onClick={() =>
                    history.push(`/app/comunidade-eventos/${evento.id}`)
                  }
                >
                  <TableCell
                    sx={{
                      fontWeight: "bolder",
                      color: "gray",
                      cursor: "pointer",
                    }}
                    component="th"
                    scope="row"
                  >
                    {evento.nome}
                  </TableCell>
                  <TableCell>{evento.descricao}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box> */}
    </div>
  );
}
